import { ApolloLink } from '@apollo/client';
import PossibleTypes from '../../schema/possibleTypes.json';
import anonymousTypes from '../../schema/anonymousTypes.json';
import createV2ApolloLink from './createV2ApolloLink';
const { possibleTypes } = PossibleTypes;
export default function getV2SchemaConfig(fetch, apolloLinks, routeThroughEdge) {
    return {
        graphql: {
            apolloLink: ApolloLink.from([
                ...apolloLinks,
                createV2ApolloLink(fetch, routeThroughEdge)
            ]),
            possibleTypes,
            anonymousTypes
        }
    };
}

//# sourceMappingURL=getV2SchemaConfig.js.map